import React, {FC} from 'react';
import {useTranslation} from "react-i18next";
import {itemPrice} from "../../data/price";

interface QuantityDropDownProps {
    prices: itemPrice[],
    quantity: number | null,
    onQuantityChange: (quantity: number) => void,
    label: string,
    itemType: string
}

const QuantityDropDown: FC<QuantityDropDownProps> = ({prices, onQuantityChange, quantity,label, itemType}) => {
    const {t} = useTranslation();
    return (
        <div className="flex justify-center">
            <div className="mb-3 w-full p-2">
                <label htmlFor="quantity"
                       className="form-label inline-block mb-2 text-gray-700">{label}</label>
                <select value={quantity ? quantity : 0}
                        id="quantity"
                        className="form-select appearance-none
                              block
                              w-full
                              px-3
                              py-1.5
                              text-base
                              font-normal
                              text-gray-700
                              bg-white bg-clip-padding bg-no-repeat
                              border border-solid border-orange-200
                              rounded
                              m-0
                              focus:text-gray-700
                              focus:bg-white
                              focus:border-orange-200
                              focus:shadow-none
                              focus:outline-none"
                        onChange={(e) => {
                            onQuantityChange(parseInt(e.target.value, 10))
                        }}>
                    <option value="">{t('selectGunQuantity', {
                        "gunType": t(itemType + "Dropdown")
                    })}</option>
                    {prices.map((item, index) => {
                        return <option key={index}
                                       value={item.quantity}>{t('quantityDropdownOptionLabel', {
                                        "quantity": item.quantity,
                                        "gunType": t(itemType + "Dropdown"),
                                        "price": item.price
                                       })}</option>
                    })}
                </select>
            </div>
        </div>
    );
};

export default QuantityDropDown;
